import React, { useEffect, useState } from "react";
import { FiDownload } from "react-icons/fi";
import "./PwaInstallButton.css";

const isStandaloneMode = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches ||
  window.navigator.standalone === true;

const PwaInstallButton = ({ compact = false }) => {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandaloneMode());

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };

    const handleInstalled = () => {
      setInstalled(true);
      setInstallPrompt(null);
    };

    const media = window.matchMedia?.("(display-mode: standalone)");
    const handleDisplayModeChange = () => setInstalled(isStandaloneMode());

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleInstalled);
    media?.addEventListener?.("change", handleDisplayModeChange);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleInstalled);
      media?.removeEventListener?.("change", handleDisplayModeChange);
    };
  }, []);

  const handleInstall = async () => {
    if (installPrompt) {
      await installPrompt.prompt();
      await installPrompt.userChoice;
      setInstallPrompt(null);
      return;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    if (isIOS) {
      window.alert(
        'No Safari, toque em "Compartilhar" e depois em "Adicionar à Tela de Início".'
      );
      return;
    }

    window.alert(
      'Se a instalação não abrir automaticamente, use o menu do navegador e escolha "Instalar app" ou "Adicionar à tela inicial".'
    );
  };

  if (installed) return null;

  return (
    <button
      type="button"
      className={`PwaInstall_button ${compact ? "PwaInstall_button--compact" : ""}`}
      onClick={handleInstall}
      title="Instalar Stronda Music Telemetria"
    >
      <FiDownload className="PwaInstall_icon" />
      <span>Instalar App</span>
    </button>
  );
};

export default PwaInstallButton;
